import React from 'react';
import Spinner from 'react-spinner';
import { Table } from 'react-bootstrap';

import fetchContent from '../../../helpers/backend-communication';

import CountryProfileModal from './Modal';
import CountryProfileReportList from './ItemReportList';
import NationalContactsContentList from '../../NationalContacts/NationalContactsContentList';

function formatAnswer(answer) {
  if (answer === 'N/A') {
    return 'No Answer'
  }
  if (answer === 'True') {
    return 'Checked'
  }
  if (answer === 'False') {
    return 'Not checked'
  }
  return answer
}

function sortReportsByMostRecent(reportList) {
  return reportList.sort(function(itemA, itemB) {
    const yearA = itemA.attributes.reportingYear,
      yearB = itemB.attributes.reportingYear;

    if (yearA < yearB) {
      return 1;
    } else if (yearA > yearB) {
      return -1;
    }

    return 0;
  });
}

class CountryProfileMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reports: [],
      npc: null,
      isLoadingReports: false,
      isLoadingNPC: false,
      latestReportsComparison: null,
      isLoadingLatestReportsComparison: false,
    };
  }

  componentDidMount() {
    console.log('Fetching report list for country profile....');

    this.setState({
      isLoadingReports: true,
      isLoadingNPC: true,
      isLoadingLatestReportsComparison: true,
    });

    this.getReportList();
    this.getNPC();
    this.getLatestReportsComparison();
  }

  getReportList() {
    fetchContent('reports', `?country__iso_alpha_3=${ this.props.countryCode }`)
      .then(responseObject => {
        const reportList = responseObject.data;
        sortReportsByMostRecent(reportList);

        this.setState({
          reports: reportList,
          isLoadingReports: false
        });
      })
      .catch(error => {
        this.setState({
          reports: [],
          isLoadingReports: false
        });
        console.error('Fetch report list went wrong', error);
      });
  }

  getNPC() {
    console.log('Fetching npc for country profile....');

    fetchContent('npcComplete', `?country=${ this.props.countryCode }`)
      .then(responseObject => {
        this.setState({
          npc: responseObject,
          isLoadingNPC: false
        });
      })
      .catch(error => {
        this.setState({
          npc: null,
          isLoadingNPC: false
        });
        console.error('Fetch npc went wrong', error);
      });
  }

  getLatestReportsComparison() {
    console.log('Fetching latest reports comparison...');

    fetchContent('countryprofileComparison', `/${ this.props.countryCode }`)
      .then(responseObject => {
        this.setState({
          latestReportsComparison: responseObject,
          isLoadingLatestReportsComparison: false
        });
      })
      .catch(error => {
        this.setState({
          latestReportsComparison: null,
          isLoadingLatestReportsComparison: false
        });
        console.error('Fetch latest reports comparison went wrong', error);
      });
  }

  renderNPC() {
    if (this.state.isLoadingNPC) return <Spinner className="national-contacts__spinner" />;

    return (
      <NationalContactsContentList
        className='country-profile-menu__item-npc'
        data={ this.state.npc }
      />
    );
  }

  renderReportList() {
    return (
      <CountryProfileReportList
        reports={ this.state.reports }
        isLoading={ this.state.isLoadingReports }
      />
    );
  }

  renderLastReport() {
    const report = this.state.reports && this.state.reports.length > 0 ? this.state.reports[0] : null;
    const reportUrl = report && report.links && report.links.reportFile ? report.links.reportFile : '#';
    const reportYear = report && report.attributes && report.attributes.reportingYear ? report.attributes.reportingYear : '----';

    return (
     <span>
        Last report:&nbsp;
        <a target="_blank" rel="noopener noreferrer" className="country-profile-menu__button"
          href={ reportUrl }
        >
          { reportYear }
        </a>
      </span>
    );
  }

  renderLatestReportsComparison() {
    if (this.state.isLoadingLatestReportsComparison) {
      return <Spinner className="national-contacts__spinner" />;
    }

    const { latestReportsComparison } = this.state;

    if (!latestReportsComparison) {
      return <span>Insufficient data to display latest reports comparison for this Country.</span>
    }

    return (
      <Table striped bordered hover>
        <thead>
          <th>Section</th>
          <th>Question</th>
          <th>{ latestReportsComparison.year_old }</th>
          <th>{ latestReportsComparison.year_actual }</th>
        </thead>
        <tbody>
          { latestReportsComparison.sections.map((section) =>
            section.sub_sections.map((sub_section) => sub_section.questions.map((question, index) => (
              <tr key={`question-${question.id}`}>
                { index === 0 ? (
                  <td rowSpan={sub_section.questions.length}>{ sub_section.name }</td>
                ) : null }
                <td style={{ whiteSpace: 'pre-wrap' }}>{ question.question }</td>
                <td>{ formatAnswer(question[latestReportsComparison.year_old])}</td>
                <td>{ formatAnswer(question[latestReportsComparison.year_actual])}</td>
              </tr>
            ) : null)
          ))}
        </tbody>
      </Table>
    )
  }

  render() {
    const NPCFormatted = this.renderNPC()
    const reportListFormatted = this.renderReportList()
    const latestReportsComparison = this.renderLatestReportsComparison()

    return (
      <div className="country-profile-menu">
        { this.renderLastReport() }

         <CountryProfileModal
          title={"Submitted reports of " + this.props.countryName}
          content={reportListFormatted}
          size="medium"
        >
          <span className="country-profile-menu__icon glyphicon glyphicon-list-alt"></span>
          <span className="country-profile-menu__button"> All reports</span>
        </CountryProfileModal>

        <CountryProfileModal
          title={"National point of contact of " + this.props.countryName}
          content={NPCFormatted}
        >
          <span className="country-profile-menu__icon glyphicon glyphicon-home"></span>
          <span className="country-profile-menu__button">NPC</span>
        </CountryProfileModal>

        <CountryProfileModal
          title="Latest Reports Comparison"
          content={latestReportsComparison}
        >
          <span className="country-profile-menu__icon glyphicon glyphicon-duplicate"></span>
          <span className="country-profile-menu__button">Latest Reports Comparison</span>
        </CountryProfileModal>
      </div>
    );
  }
}

export default CountryProfileMenu;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/Menu/index.js